(() => {
  const publish = (name, detail = {}) => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (!window.Shopify?.analytics?.publish) return;
    Promise.resolve(window.Shopify.analytics.publish(name, detail)).catch(() => {});
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-studio-cta]');
    if (link) publish('studio_cta_clicked', {placement: link.dataset.studioCta});
  });
  for (const event of ['builder_viewed', 'design_ready', 'cart_submitted']) {
    document.addEventListener('studio:' + event, e => publish('studio_' + event, e.detail || {}));
  }
})();
